import { render } from "./ActionMenu.vue?vue&type=template&id=29840517&ts=true&lang=pug"
import script from "./ActionMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionMenu.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__